import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Todos API
export const todosAPI = {
  getAll: (params = {}) => api.get('/todos', { params }),
  getById: (id) => api.get(`/todos/${id}`),
  create: (data) => api.post('/todos', data),
  update: (id, data) => api.put(`/todos/${id}`, data),
  delete: (id) => api.delete(`/todos/${id}`),
  batchUpdate: (updates) => api.post('/todos/batch-update', { updates }),
};

// Categories API
export const categoriesAPI = {
  getAll: () => api.get('/categories'),
  getById: (id) => api.get(`/categories/${id}`),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  delete: (id) => api.delete(`/categories/${id}`),
};

// Tags API
export const tagsAPI = {
  getAll: () => api.get('/tags'),
  create: (data) => api.post('/tags', data),
  update: (id, data) => api.put(`/tags/${id}`, data),
  delete: (id) => api.delete(`/tags/${id}`),
};

// Tracking API
export const trackingAPI = {
  getAll: (params = {}) => api.get('/tracking', { params }),
  create: (data) => api.post('/tracking', data),
  update: (id, data) => api.put(`/tracking/${id}`, data),
  delete: (id) => api.delete(`/tracking/${id}`),
  getStats: (params = {}) => api.get('/tracking/stats', { params }),
};

// User API
export const userAPI = {
  getProfile: () => api.get('/user'),
  updateProfile: (data) => api.put('/user', data),
};

export default api;
